"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Collection {
    /**
     * @param list
     * @param compareCallback by default indexOf is used to find entries, add a custom compare callback if necessary
     */
    constructor(list = [], compareCallback) {
        this.list = list;
        this.compareCallback = compareCallback;
    }
    add(entry) {
        this.list.push(entry);
    }
    contains(entry) {
        return this.indexOf(entry) !== -1;
    }
    length() {
        return this.list.length;
    }
    reduce(func, initialValue) {
        return this.list.reduce(func, initialValue);
    }
    /**
     * Creates a new collection containing only items that passed given filter function.
     */
    filter(filter) {
        return new Collection(this.list.filter(filter), this.compareCallback);
    }
    /**
     * Will return first item of the collection, or the first item matching passed filter function.
     * Will return null if the list is empty or no items match filter.
     */
    firstOrNull(filter) {
        var _a;
        if (filter === undefined) {
            return (_a = this.list[0]) !== null && _a !== void 0 ? _a : null;
        }
        for (const element of this.list) {
            if (filter(element)) {
                return element;
            }
        }
        return null;
    }
    /**
     * Will return first item of the collection, or the first item matching passed filter function.
     *
     * @throws Error If the list is empty or if no items match passed filter function.
     */
    first(filter) {
        if (filter === undefined) {
            if (this.list.length > 0) {
                return this.list[0];
            }
            throw new Error('Cannot fetch first element of an empty list');
        }
        for (const element of this.list) {
            if (filter(element)) {
                return element;
            }
        }
        throw new Error('Filter matched no items');
    }
    indexOf(entry) {
        if (this.compareCallback === undefined) {
            return this.list.indexOf(entry);
        }
        for (let i = 0; i < this.list.length; i++) {
            if (this.compareCallback(this.list[i], entry)) {
                return i;
            }
        }
        return -1;
    }
    remove(entry) {
        const index = this.indexOf(entry);
        if (index !== -1) {
            this.list.splice(index, 1);
        }
    }
}
exports.default = Collection;
//# sourceMappingURL=Collection.js.map